import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionExtQueryCriteriaClass extends BaseCriteriaModel {
  guid_hdr?: Optional<string> = Optional.empty();
  guid_device?: Optional<string> = Optional.empty();
  guid_record?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();

}

export class StockTakeSessionExtCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionExtCriteriaModel: StockTakeSessionExtQueryCriteriaClass) {

    if (!stockTakeSessionExtCriteriaModel) {
      return;
    }

    this.query += stockTakeSessionExtCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&guid_hdr=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.guid_device.filter(x => x !== '').map(x => '&guid_device=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.guid_record.filter(x => x !== '').map(x => '&guid_record=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += stockTakeSessionExtCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + stockTakeSessionExtCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionExtCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionExtCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionExtCriteriaModel.offset + '&limit=' + stockTakeSessionExtCriteriaModel.limit;
  }
}
